// 购买商
/*首页
匹配展品
匹配展商
展商详情页
展品详情页
我的需求
发布需求
商贸配对活动
商贸配对活动-活动详情
热门视频列表
直播查看
我的预约
我的日程
我的资料
我的消息*/

export default [

  {
    name: "wenxing-purchaser-my",
    path: "/purchaser/my",
    meta: {
      title: "我的"
    },
    component: () => import("@wenxing/pages/purchaser/my/index.vue")
  },
  //个人中心的所有东西都是meLayout的子路由
  {
    path: "/me/purchaser",
    meta: {
      title: "个人中心"
    },
    redirect:"/me/purchaser/requirement",
    component: () => import("../../pages/me/meLayout.vue"),
    children: [
      {
        name: "个人信息",
        path: "/me/purchaser/profile",
        meta: {
          title: "个人信息"
        },
        component: () => import("@wenxing/pages/purchaser/center.vue")
      },
      {
        name: "观众我的消息",
        path: "/me/purchaser/message",
        meta: {
          title: "观众我的消息"
        },
        component: () => import("../../pages/message/message")
      },
      {
        name: "观众我的收藏",
        path: "collectAndLike",
        meta: {
          title: "观众我的收藏"
        },
        component: () =>
          import("../../pages/collectAndLikePurchase/collectAndLikePurchase")
      },
      /*我的需求*/
      {
        meta: {
          title: "我的需求"
        },
        name: "我的需求",
        path: "requirement",
        component: () =>
          import("@wenxing/pages/purchaser/requirement/index.vue")
      },
      /*发布需求*/
      {
        meta: {
          title: "个人中心-发布需求"
        },
        name: "个人中心-发布需求",
        path: "requirement/add",
        component: () =>
          import("@wenxing/pages/purchaser/requirement/modify.vue")
      },
      // 修改需求
      {
        meta: {
          title: "个人中心-修改需求"
        },
        name: "wenxing-purchaser-requirement-edit",
        path: "requirement/edit",
        component: () =>
          import("@wenxing/pages/purchaser/requirement/modify.vue")
      },
      {
        meta: {
          title: "我的预约"
        },
        name: "reservation",
        path: "reservation",
        component: () => import("@wenxing/pages/reservation/myReservation.vue")
      },
      {
        meta: {
          title: "我的日程"
        },
        name: "我的日程",
        path: "schedule",
        component: () => import("@wenxing/pages/reservation/mySchedule.vue")
      },
      {
        meta: {
          title: "message"
        },
        name: "message",
        path: "message",
        component: () => import("@wenxing/pages/message/message.vue")
      },
      //商贸配对活动列表
      {
        name: "商贸配对活动列表",
        path: "/me/purchaser/tradeMatchingActivities/list",
        component: () =>
          import("@wenxing/pages/purchaser/tradeMatchingActivities/list.vue")
      },
      //商贸配对活动 活动详情查看
      {
        name: "wenxing-purchaser-tradeMatchingActivities-detail",
        path: "/me/purchaser/tradeMatchingActivities/detail",
        component: () =>
          import("@wenxing/pages/purchaser/tradeMatchingActivities/detail.vue")
      },
    ]
  },



];




// WEBPACK FOOTER //
// ./src/wenxing/router/purchaser/index.js